import { render, staticRenderFns } from "./TabContainer.vue?vue&type=template&id=269a3ef6&"
import script from "./TabContainer.vue?vue&type=script&lang=ts&"
export * from "./TabContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports